<template>
  <div id="app">
    <Header/>
    <router-view/>
    <div id="footer">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
export default {
  name: 'app',
  components: {
    Header,
    Footer
  }
}
</script>

<style>

body{
    background-image:url("./assets/back_img.jpg");
    background-attachment: fixed;
}
#footer{
  /* position:absolute; */
  position: fixed; /* 要素の位置を固定する */
  padding-top:20px;
  /* bottom: 1;
  right: 0; */
  /* background:red; */
}
</style>
